// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Vector.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  width: 100%;
  height: 3em;
  color: #426ba6;
  z-index: 100;
  background: #bfcde2;
  border: 0.3px solid #88a5cf;
  border-radius: 0px 0px 1px 1px;
  display: flex;
  justify-content: center;
  position: fixed;
}
.navbar__container {
  width: 100%;
  max-width: 2000px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2px 1rem;
}
.navbar__logo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 10px;
  height: 30px;
  flex: none;
  order: 0;
  flex-grow: 0;
}
.navbar h1 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1em;
  line-height: 18px;
  display: flex;
  align-items: center;
}
.navbar__datetime_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 19px;
  gap: 2em;
  width: 100%;
}
.navbar__datetime {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.navbar__right {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
}
.navbar__lang-switch {
  display: flex;
  align-items: center;
  gap: 6px;
  -webkit-user-select: none;
          user-select: none;
  margin-right: 5px;
}
@media screen and (min-width: 1440px) {
  .navbar__lang-switch {
    font-size: 14px;
    line-height: 16px;
  }
}
.navbar__lang-label {
  font-weight: 600;
  font-size: 0.95em;
  opacity: 0.55;
}
.navbar__lang-label.active {
  opacity: 1;
}
.navbar__lang-toggle {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
}
.navbar__lang-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}
.navbar__lang-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(66, 107, 166, 0.35);
  transition: 0.2s;
  border-radius: 999px;
}
.navbar__lang-slider::before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 1px;
  top: 1px;
  background-color: #426ba6;
  transition: 0.2s;
  border-radius: 999px;
}
.navbar__lang-toggle input:checked + .navbar__lang-slider {
  background-color: rgba(66, 107, 166, 0.15);
}
.navbar__lang-toggle input:checked + .navbar__lang-slider::before {
  transform: translateX(20px);
}
.navbar .user_label__container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  /* height: 1.5em; */
  font-weight: 500;
  font-size: 1em;
  line-height: 1.2em;
}
.navbar .user_label__container img {
  width: 1em;
  height: 1.1em;
  margin-left: 0.5em;
  margin-top: 0.2em;
  cursor: pointer;
}
.navbar .user_label {
  display: block;
  width: auto;
  /*  */
}
.navbar .user_label span {
  padding-bottom: 0.1em;
  font-size: 1em;
}
.navbar ul {
  display: flex;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
  padding-inline-start: 0;
}
.navbar a {
  text-decoration: none;
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), pointer;
  color: #426ba6;
}
@media screen and (min-width: 1024px) {
  .navbar {
    font-size: 12px;
    line-height: 13px;
  }
}
@media screen and (min-width: 1440px) {
  .navbar {
    font-size: 15px;
    line-height: 17px;
  }
}

.nav-item {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), pointer;
  list-style: none;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.1em;
  line-height: 1.3em;
  padding-left: 5px;
  padding-right: 5px;
  color: #426ba6;
  height: 100%;
}
.nav-item a,
.nav-item span {
  font-weight: 500;
}

.navHover:hover {
  color: rgba(136, 166, 207, 0.8666666667);
}

.dropdown {
  z-index: 102;
  position: absolute;
  width: auto;
  min-width: 100px;
  background-color: white;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;
}
.dropdown li {
  z-index: 102;
  padding: 0;
  margin-right: 5px;
  margin-left: 3px;
}
.dropdown a {
  font-weight: 400;
}
.dropdown a:hover {
  color: rgba(136, 166, 207, 0.8666666667);
}

.menu-item {
  height: 18px;
}
.menu-item a {
  font-weight: 400;
}
.menu-item a:hover {
  color: rgba(136, 166, 207, 0.8666666667);
}

.accented {
  border: 1px solid #ff073a;
  box-shadow: rgba(255, 7, 58, 0.25) 2px 5px 12px, rgba(255, 7, 58, 0.12) -2px -12px 15px, rgba(255, 7, 58, 0.12) 0px 4px 6px, rgba(255, 7, 58, 0.17) 0px 4px 13px, rgba(255, 7, 58, 0.09) 0px -3px 5px;
}`, "",{"version":3,"sources":["webpack://./src/Components/NavBar/src/NavBar.scss","webpack://./src/Components/App/vars.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,aAAA;EAEA,uBAAA;EACA,eAAA;AADF;AAEE;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AAAJ;AAEE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;AADJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AADJ;AAOE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iBAAA;AANJ;AAOI;EANF;IAOI,eAAA;IACA,iBAAA;EAJJ;AACF;AAOE;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;AALJ;AAOI;EACE,UAAA;AALN;AASE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAPJ;AASI;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAPN;AAWE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,0CAAA;EACA,gBAAA;EACA,oBAAA;AATJ;AAWI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;AATN;AAaE;EACE,0CAAA;AAXJ;AAcE;EACE,2BAAA;AAZJ;AAeE;EACE,aAAA;EAEA,WAAA;EAEA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAfJ;AAgBI;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAdN;AAiBE;EAEE,cAAA;EACA,WAAA;EACA,KAAA;AAhBJ;AAkBE;EACE,qBAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAjBJ;AAsBE;EACE,qBAAA;EACA,wDAAA;EACA,cAAA;AApBJ;AAuBE;EAtLF;IAuLI,eAAA;IACA,iBAAA;EApBF;AACF;AAqBE;EA1LF;IA2LI,eAAA;IACA,iBAAA;EAlBF;AACF;;AAoBA;EACE,wDAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAjBF;AAkBE;;EAEE,gBAAA;AAhBJ;;AAqBE;EACE,wCAAA;AAlBJ;;AAsBA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,iDC9NY;ED+NZ,iFAAA;AAnBF;AAoBE;EACE,YAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;AAlBJ;AAoBE;EACE,gBAAA;AAlBJ;AAmBI;EACE,wCAAA;AAjBN;;AAqBA;EACE,YAAA;AAlBF;AAmBE;EACE,gBAAA;AAjBJ;AAkBI;EACE,wCAAA;AAhBN;;AAyCA;EACE,yBAAA;EACA,qMAAA;AAtCF","sourcesContent":["@import \"../../App/vars.scss\";\n.navbar {\n  width: 100%;\n  height: 3em;\n  color: #426ba6;\n  z-index: 100;\n  background: #bfcde2;\n  border: 0.3px solid #88a5cf;\n  border-radius: 0px 0px 1px 1px;\n  display: flex;\n\n  justify-content: center;\n  position: fixed;\n  &__container {\n    width: 100%;\n    max-width: 2000px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2px 1rem;\n  }\n  &__logo {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0px;\n    gap: 10px;\n    height: 30px;\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n  }\n  h1 {\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 1em;\n    line-height: 18px;\n    display: flex;\n    align-items: center;\n  }\n\n  &__datetime_wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    height: 19px;\n    gap: 2em;\n    width: 100%;\n  }\n  &__datetime {\n    display: flex;\n    flex-direction: column;\n    margin-left: 10px;\n    h1 {\n      // width: 100px;\n    }\n  }\n\n  &__right {\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 14px;\n  }\n\n  &__lang-switch {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    user-select: none;\n    margin-right: 5px;\n    @media screen and (min-width: 1440px) {\n      font-size: 14px;\n      line-height: 16px;\n    }\n  }\n\n  &__lang-label {\n    font-weight: 600;\n    font-size: 0.95em;\n    opacity: 0.55;\n\n    &.active {\n      opacity: 1;\n    }\n  }\n\n  &__lang-toggle {\n    position: relative;\n    display: inline-block;\n    width: 42px;\n    height: 22px;\n\n    input {\n      opacity: 0;\n      width: 0;\n      height: 0;\n    }\n  }\n\n  &__lang-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.65);\n    border: 1px solid rgba(66, 107, 166, 0.35);\n    transition: 0.2s;\n    border-radius: 999px;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      height: 18px;\n      width: 18px;\n      left: 1px;\n      top: 1px;\n      background-color: #426ba6;\n      transition: 0.2s;\n      border-radius: 999px;\n    }\n  }\n\n  &__lang-toggle input:checked + &__lang-slider {\n    background-color: rgba(66, 107, 166, 0.15);\n  }\n\n  &__lang-toggle input:checked + &__lang-slider::before {\n    transform: translateX(20px);\n  }\n\n  .user_label__container {\n    display: flex;\n    // flex-direction: row;\n    width: 100%;\n    // text-align: right;\n    align-items: center;\n    justify-content: flex-end;\n    /* height: 1.5em; */\n    font-weight: 500;\n    font-size: 1em;\n    line-height: 1.2em;\n    img {\n      width: 1em;\n      height: 1.1em;\n      margin-left: 0.5em;\n      margin-top: 0.2em;\n      cursor: pointer;\n    }\n  }\n  .user_label {\n    // padding-right: 2rem;\n    display: block;\n    width: auto;\n    /*  */\n  }\n  .user_label span {\n    padding-bottom: 0.1em;\n    font-size: 1em;\n  }\n\n  ul {\n    display: flex;\n    align-items: center;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-inline-start: 0;\n  }\n\n  p {\n  }\n  a {\n    text-decoration: none;\n    cursor: url(\"Vector.png\"), pointer;\n    color: #426ba6;\n  }\n\n  @media screen and (min-width: 1024px) {\n    font-size: 12px;\n    line-height: 13px;\n  }\n  @media screen and (min-width: 1440px) {\n    font-size: 15px;\n    line-height: 17px;\n  }\n}\n.nav-item {\n  cursor: url(\"Vector.png\"), pointer;\n  list-style: none;\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1.1em;\n  line-height: 1.3em;\n  padding-left: 5px;\n  padding-right: 5px;\n  color: #426ba6;\n  height: 100%;\n  a,\n  span {\n    font-weight: 500;\n  }\n}\n\n.navHover {\n  &:hover {\n    color: #88a6cfdd;\n  }\n}\n\n.dropdown {\n  z-index: 102;\n  position: absolute;\n  width: auto;\n  min-width: 100px;\n  background-color: white;\n  border: $border-thin;\n  box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;\n  li {\n    z-index: 102;\n    padding: 0;\n    margin-right: 5px;\n    margin-left: 3px;\n  }\n  a {\n    font-weight: 400;\n    &:hover {\n      color: #88a6cfdd;\n    }\n  }\n}\n.menu-item {\n  height: 18px;\n  a {\n    font-weight: 400;\n    &:hover {\n      color: #88a6cfdd;\n    }\n  }\n}\n\n// @media screen and (min-width: 1805px) {\n//   .navbar {\n//     height: 43px;\n//     li,\n//     h1 {\n//       font-size: 15px;\n//       line-height: 20px;\n//     }\n//   }\n// }\n// @media screen and (min-width: 1905px) {\n//   .navbar {\n//     height: 45px;\n//     li,\n//     h1 {\n//       font-size: 15px;\n//       line-height: 22px;\n//     }\n//   }\n// }\n.accented {\n  border: 1px solid #ff073a;\n  box-shadow: rgba(255, 7, 58, 0.25) 2px 5px 12px, rgba(255, 7, 58, 0.12) -2px -12px 15px,\n    rgba(255, 7, 58, 0.12) 0px 4px 6px, rgba(255, 7, 58, 0.17) 0px 4px 13px, rgba(255, 7, 58, 0.09) 0px -3px 5px;\n}\n","$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$accentFilterColor: #ff8040;\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
